export default "__VITE_ASSET__BmJf12YD__"